import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { TasksAssignedToMePage } from "src/components/views/tasks/pages/TasksAssignedToMePage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/tasks/my")({
	staticData: { title: i18n.t("own_tasks"), legacyViewKey: "tasksAssignedToMePage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <TasksAssignedToMePage />;
}
